import React from "react";
import { BqnCell } from "../../BqnCell";

const doesNothing = () => {};

const DeleteVLANButton = ({ onClick = doesNothing }) => (
  <a className="action waves-effect borderless" onClick={onClick}>
    <i className="material-icons">delete</i>
  </a>
);

const VLANItem = ({
  id,
  tag = "",
  deleted,
  even = false,
  onDelete = doesNothing,
  showBqn = false,
  bqns = [],
}) => {
  if (deleted === true) {
    return null;
  }
  const doVLANDelete = () => {
    onDelete(id);
  };

  const onClick = () => {
    if (showBqn) {
      showModalConfirm(
        "Remove tag for all BQN's?",
        "The tag will be removed for all BQN's in the cluster when Applied, please use the other tabs if you want to remove just for specific BQNs.",
        "warning",
        () => doVLANDelete(),
        () => null,
        "OK",
        "CANCEL",
      );
    } else {
      doVLANDelete();
    }
  };

  return (
    <React.Fragment>
      <tr className={`${even ? "even" : "odd"}`}>
        {showBqn && <BqnCell bqns={bqns} />}
        <td>{tag}</td>
        <td className="text-center hides-content-to-operators">
          <DeleteVLANButton onClick={onClick} />
        </td>
      </tr>
    </React.Fragment>
  );
};
const VLANsList = ({
  items = [],
  onDelete = doesNothing,
  onEdit = doesNothing,
  bqn,
  metadata,
}) => (
  <table className="table">
    <thead>
      <tr>
        {bqn === "all" ? <th>BQN</th> : null}
        <th>TAGS TO BYPASS</th>
        <th className="text-center">ACTIONS</th>
      </tr>
    </thead>
    <tbody>
      {items
        .filter(({ deleted }) => deleted !== true)
        .map(({ __id, ...client }, index) => (
          <VLANItem
            id={__id}
            key={__id}
            {...client}
            even={(index + 1) % 2 === 0}
            onDelete={() => onDelete(__id)}
            onEdit={() => onEdit(__id)}
            showBqn={bqn === "all"}
            bqns={metadata?.vlans[client.tag]}
          />
        ))}
    </tbody>
  </table>
);
export default VLANsList;
